/* ACP V9 — TikTok in-app browser hint. Compact by default: a slim one-line bar that
   never pushes people out of the shop. The full instructions open only on tap. */
(function () {
  'use strict';
  var box = document.getElementById('acp-tiktok-help');
  if (!box || !/tiktok|musical_ly|musically|bytedance|trill/i.test(navigator.userAgent || '')) return;
  var words = {
    de: {toggle:'Probleme beim Bestellen? Im Browser öffnen',title:'So kannst du bestellen',description:'Produktseiten oder Kasse öffnen sich in TikTok nicht? Öffne unseren Shop in deinem Browser.',step1:'Tippe oben rechts auf die drei Punkte ···',step2:'Wähle «Im Browser öffnen».',copy:'Shopadresse kopieren',copied:'Kopiert. Öffne Safari oder Chrome und füge die Adresse ein.',fallback:'Halte die Adresse gedrückt und kopiere sie. Öffne sie danach in Safari oder Chrome.',close:'Hinweis schliessen'},
    sq: {toggle:'Probleme me porosinë? Hape në shfletues',title:'Kështu mund të porositësh',description:'Produktet ose pagesa nuk hapen në TikTok? Hape dyqanin në shfletuesin tënd.',step1:'Preki tri pikat ··· lart djathtas.',step2:'Zgjidh «Hap në shfletues».',copy:'Kopjo adresën e dyqanit',copied:'U kopjua. Hape Safari ose Chrome dhe ngjite adresën.',fallback:'Mbaje shtypur adresën dhe kopjoje. Pastaj hape në Safari ose Chrome.',close:'Mbyll njoftimin'},
    en: {toggle:'Trouble ordering? Open in browser',title:'How to place your order',description:'Products or checkout won’t open in TikTok? Open our shop in your browser.',step1:'Tap the three dots ··· at the top right.',step2:'Choose “Open in browser”.',copy:'Copy shop address',copied:'Copied. Open Safari or Chrome and paste the address.',fallback:'Press and hold the address to copy it, then open it in Safari or Chrome.',close:'Dismiss notice'}
  };
  var lang = (document.documentElement.lang || navigator.language || 'de').split('-')[0];
  if (!words[lang]) lang = 'en';
  try { var saved = sessionStorage.getItem('acp-tt-language'); if (saved && words[saved]) lang = saved; } catch (_) {}
  try { if (sessionStorage.getItem('acp-tt-dismissed') === '1') return; } catch (_) {}

  var toggle = box.querySelector('.acp-tt-toggle');
  var panel = box.querySelector('.acp-tt-inner');

  function render() {
    var w = words[lang];
    ['title', 'description', 'step1', 'step2', 'copy'].forEach(function (k) { box.querySelector('.acp-tt-' + k).textContent = w[k]; });
    box.querySelector('.acp-tt-toggle-text').textContent = w.toggle;
    box.querySelector('.acp-tt-close').setAttribute('aria-label', w.close);
    box.setAttribute('lang', lang);
    box.querySelector('.acp-tt-status').textContent = '';
    box.querySelectorAll('[data-tt-lang]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.ttLang === lang)); });
  }
  toggle.addEventListener('click', function () {
    var open = panel.hidden;
    panel.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    box.classList.toggle('is-open', open);
  });
  box.querySelectorAll('[data-tt-lang]').forEach(function (b) {
    b.addEventListener('click', function () { lang = b.dataset.ttLang; render(); try { sessionStorage.setItem('acp-tt-language', lang); } catch (_) {} });
  });
  box.querySelector('.acp-tt-close').addEventListener('click', function () {
    box.hidden = true;
    try { sessionStorage.setItem('acp-tt-dismissed', '1'); } catch (_) {}
  });
  box.querySelector('.acp-tt-copy').addEventListener('click', function () {
    var input = box.querySelector('.acp-tt-url');
    var status = box.querySelector('.acp-tt-status');
    function fallback() { input.hidden = false; input.focus(); input.select(); status.textContent = words[lang].fallback; }
    if (!navigator.clipboard || !navigator.clipboard.writeText) return fallback();
    navigator.clipboard.writeText(input.value).then(function () { status.textContent = words[lang].copied; }, fallback);
  });
  render();
  box.hidden = false;
})();
